import { EnvironmentService } from 'phoenix/services';

export function LongClickDirective($timeout:ng.ITimeoutService, EnvironmentService:EnvironmentService) {
	return {
		restrict: 'A',
		link: function($scope, $elm, $attrs) {
			var timer = null;
			var disableClick = false;
			var _mdListTargeted = false;
			//detect touch set the target event
			var _startEvent = 'mousedown';
			var _endEvent = 'mouseup mouseleave';
			if(EnvironmentService.touchEnabled){
				_startEvent = 'touchstart';
				_endEvent = 'touchend touchmove';
			}

			retargetElement($elm);

			function start(event) {					
				//not a left click
				if(event.type === 'mousedown' && event.which !== 1){ return;}

				//left click
				timer = $timeout(function() {	
					disableClick = true;
					$scope.$eval($attrs.pxOnLongClick);

					if(_mdListTargeted){
						//disable button to eliminate click event firing
						$elm.attr('disabled', true);
						$timeout(function(){
							$elm.removeAttr('disabled');
							disableClick = false;
						}, 600);
					}

				}, 600);
			}

			function end(event) {
				if(!disableClick){
					$timeout.cancel(timer);
				}
			}

			function click(event){
				if(disableClick){
					event.stopImmediatePropagation();
					event.stopPropagation();
					event.preventDefault();
					disableClick = false;
					
					$timeout.cancel(timer);
					return;
				}
			}

			function retargetElement(elm){
				switch(elm[0].tagName){
					case 'MD-LIST-ITEM':
						_mdListTargeted = true;
						$timeout(function(){
							//timeout till the next digest cycle to verify all templates have rendered
							$elm = angular.element(elm[0].querySelector('button.md-button'));
							$elm.on(_startEvent, start);
							$elm.on('click', click);
							$elm.on(_endEvent, end);
						},0);
						break;
					default:
						$elm.on(_startEvent, start);
						$elm.on('click', click);
						$elm.on(_endEvent, end);
				}
			}

			$scope.$on('$destroy',function(ev){
				$elm.off(_startEvent, start);
				$elm.off(_endEvent, end);
				$elm.off('click',click);
				// On short clicks, it looks like the $destroy handler is getting called before
				// the touchend event gets fired. To mitigate this, manually clean up timer in
				// this handler if necessary
				if (timer) {
					end(ev);
				}
			});
		}
	};
}

LongClickDirective.$inject = [
	'$timeout', 
	'pxEnvironmentService'
];


// WEBPACK FOOTER //
// ./src/phoenix/components/onLongClick/onLongClick.ts